module.exports = __webpack_public_path__ + "static/media/T-base-image.a6532cbe.png";